import React from 'react';
import './HelperTextsStyles.scss';
interface  Helpertexts {
title: string;
subTitle: string;
}

const HelperTexts: React.FC<Helpertexts> = props => {
const {
    title,
    subTitle
} = props;
return (
    <div className="header-section">
        <div className="header-title">
          {title}
        </div>
        <div className="header-subtitle">
          {subTitle}
        </div>
    </div>
)
};

export default HelperTexts;